<div class="wcl-addon-link" (click)="openDialog()">
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z"></path>
    <path d="M5 5h6v2H7v10h10v-4h2v6H5V5z"></path>
  </svg>
</div>
